import { c as _c } from "react/compiler-runtime";
export default function MuteStatusChat() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_2"><div>{"\uCC44\uD305\uAE08\uC9C0 \uC0C1\uD0DC\uC785\uB2C8\uB2E4."}</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}